export { Switch } from './Switch.component';
